const storagePrefix = process.env.VUE_APP_STORAGE_PREFIX || "ontheclocknow_";

export const THEME_STORAGE_KEY = `${storagePrefix}adminTheme`;

export function getStoredTheme() {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) === "light"
      ? "light"
      : "dark";
  } catch (error) {
    return "dark";
  }
}

export function saveTheme(theme) {
  try {
    localStorage.setItem(
      THEME_STORAGE_KEY,
      theme === "light" ? "light" : "dark"
    );
  } catch (error) {
    // The selected theme still applies for this session when storage is blocked.
  }
}
